<template>
  <div class="d-flex w-full justify-space-around mt-5 mb-2">
    <v-progress-circular
      indeterminate
      :size="size ?? 200"
      :width="15"
      color="primary"
    />
  </div>
</template>
<script setup lang="ts">
defineProps({
  size: {
    type: [Number, String],
    default: 200,
  },
})
</script>
